import src from "IMAGE";
export default { src, width: 556, height: 160, blurWidth: 8, blurHeight: 2, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAYAAABllJ3tAAAAOUlEQVR42hXJsREAEBBE0avD6MCMxBgERBJdqEPxd/4Fb4P9oqrZzC4KGjoqEi0I48fDxMHCxqDFD7adM34t5DRXAAAAAElFTkSuQmCC"};
